import React from 'react'
import Signup from '../Components/signup_signin/SignUp'

function RegisterPage() {
  return (
    <Signup/>
  )
}

export default RegisterPage